import { useSearchParams } from 'react-router-dom';
import { useCOAs } from '../../../../queries/use-coa';
import { COAProvider, Entity } from '../../../../types/entity';
import ChartContainer from './ChartContainer';
import ChartOverview from './ChartOverview';

type ChartGridProps = {
    entity: Entity;
    charts: { id: string; provider: COAProvider | null }[];
};

function ChartGrid({ entity, charts }: ChartGridProps): JSX.Element {
    const [params] = useSearchParams();
    const chartId = params.get('chart');
    const coaQuery = useCOAs(entity.id, { enabled: !chartId });

    const fullCharts = coaQuery.data?.charts ?? [];

    if (chartId) {
        return <ChartContainer id={chartId} entity={entity} />;
    }

    return (
        <div>
            <div className="grid gap-4 grid-cols-[repeat(auto-fill,300px)]">
                {coaQuery.isLoading && charts.map(({ id }) => <LoadingCard key={id} />)}
                {!coaQuery.isLoading && (
                    <>
                        <ChartOverview provider={null} coa={fullCharts.find((fc) => !fc.provider)} />
                        <ChartOverview provider={COAProvider.Xero} coa={fullCharts.find((fc) => fc.provider === COAProvider.Xero)} />
                    </>
                )}
            </div>
        </div>
    );
}

function LoadingCard(): JSX.Element {
    return <div className="h-[75px] rounded-md animate-pulse bg-gray-200"></div>;
}

export default ChartGrid;
